import { watch, type WatchStopHandle } from 'vue'

import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useCustomerStore } from '@entities/customer'
import { initClarity } from '@entities/customer'
import { startAnalytics } from '@entities/customer'
import { setCustomerUserProps } from '@entities/customer'
import { trackNotificationLanding } from '@shared/lib/amplitude'

const initAnalytics = (to: RouteLocationNormalizedGeneric): void => {
  void startAnalytics()
  setCustomerUserProps()
  trackNotificationLanding(to)
  initClarity()
}

export default defineNuxtRouteMiddleware((to) => {
  const store = useCustomerStore()

  if (store.customer) {
    initAnalytics(to)
    return
  }

  let stop: WatchStopHandle | null = null

  stop = watch(
    () => store.customer,
    (customer) => {
      if (!customer) return

      try {
        initAnalytics(to)
      } finally {
        stop?.()
        stop = null
      }
    },
    {
      flush: 'post',
      immediate: false,
    },
  )
})
